export const buttonClick = label => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'eventCategory': 'mytui',
      'eventAction': 'buttonClick',
      'eventLabel': label,
      'event': 'genericTrackEvent'
    })
  } else {
    //console.log(label)
  }
}

export const push = data => {
  if (window.dataLayer) {
    window.dataLayer.push(data)
  } else {
    //console.log(data)
  }
}

export const experiment = variation => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'eventCategory': 'TUI Experiment',
      'eventAction': 'display',
      'eventLabel': variation,
      'event': 'genericTrackEventNonInteraction'
    })
  } else {
    //console.log(variation)
  }
}